export enum SynchronizationEvent {
    PROCESSES_STATISTIC = 'PROCESSES_STATISTIC',
    UPDATED_PROCESSES = 'UPDATED_PROCESSES',
    CAN_NOT_START_PROCESSES = 'CAN_NOT_START_PROCESSES',
    PROCESSES_DELETED = 'PROCESSES_DELETED',
    PROCESS_CREATED = 'PROCESS_CREATED',
    PROCESSES_ARCHIVED = 'PROCESSES_ARCHIVED',
    INSTANCE_STATISTIC_CHANGED = 'INSTANCE_STATISTIC_CHANGED',
    ADD_PROCESSES_TO_START_QUEUE = 'ADD_PROCESSES_TO_START_QUEUE'
}
